import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import ExcelToPDFUploadView from "./ExcelToPDFUploadView";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function ExcelToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Excel To PDF Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/excel_to_pdf", title: "Convert Excel To PDF Online" },
    data2: { link: "/excel_to_pdf", title: "XLS To PDF Online" },
    data3: { link: "/excel_to_pdf", title: "XlSX To PDF Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert Excel to PDF online instantly. Quickly transform spreadsheets into secure, high quality PDFs with our fast and easy Excel to PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="Excel to PDF, convert Excel to PDF, online Excel to PDF, Excel to PDF converter, spreadsheet to PDF, Excel file to PDF, Excel conversion tool, Excel to PDF online, convert XLS to PDF, XLSX to PDF, Excel PDF maker, Excel to PDF fast, secure Excel to PDF, spreadsheet PDF converter, Excel document to PDF, xls to pdf online, xlsx to pdf online, xls to pdf converter, xlsx to pdf converter,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload DOCX View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <ExcelToPDFUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["xls", "xlsx", "csv"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "text/csv": ["csv"],
              "application/vnd.ms-excel": [".xls"],
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                [".xlsx"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our Excel to PDF converter online website is a fast, reliable, and easy to use solution for converting Excel spreadsheets into high quality PDF documents. Designed to support XLS and XLSX files, this powerful Excel to PDF online converter accurately transforms tables, formulas, charts, and cell formatting into clean, well structured PDF files. Whether you are a student preparing assignments, an accountant sharing financial reports, or a business professional creating invoices and data summaries, this convert Excel to PDF online tool ensures your spreadsheets remain readable and professionally formatted. With a simple upload and convert process, users can quickly turn Excel files into PDFs without installing any software. Our Excel spreadsheet to PDF converter online works directly in your browser, saving time and improving productivity. The generated PDF files are optimized for easy sharing, printing, and long term storage, making them ideal for emails, official documentation, and record keeping. Strong security measures are in place to protect your files, with automatic deletion after conversion to maintain privacy. If you’re looking for a secure, accurate, and high performance Excel to PDF converter online that delivers consistent results without data loss or formatting issues, this website is the perfect choice for all your spreadsheet conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Excel To PDF Converter"
          why_use={[
            {
              title: "Preserve Spreadsheet Formatting",
              description:
                "This Excel to PDF converter online keeps tables, charts, formulas, fonts, and cell alignment intact. When you convert Excel to PDF online, your spreadsheets appear consistent and professional on all devices.",
            },

            {
              title: "Universal File Compatibility",
              description:
                "Using a convert Excel to PDF online tool creates PDF files that can be opened on any operating system without requiring Microsoft Excel or other spreadsheet software.",
            },

            {
              title: "Professional and Print Ready Output",
              description:
                "This Excel spreadsheet to PDF converter online generates clean, print ready documents, making it ideal for reports, invoices, financial statements, and official records.",
            },

            {
              title: "Secure and Read Only Sharing",
              description:
                "Converting Excel to PDF helps protect sensitive data from unauthorized editing. This secure Excel to PDF online website ensures safe document sharing.",
            },

            {
              title: "No Software Installation Required",
              description:
                "Our browser based Excel to PDF converter online allows users to convert Excel spreadsheets to PDF instantly without installing any software or plugins.",
            },

            {
              title: "Faster Workflow and Productivity",
              description:
                "This fast convert Excel to PDF online tool saves time by enabling quick spreadsheet conversions, improving productivity for students, professionals, and businesses.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our Excel to PDF online converter is perfect for business reports, budgets, assignments, invoices, and data analysis documents that require a professional PDF format.",
            },

            {
              title: "Optimized File Size for Easy Sharing",
              description:
                "Our Excel to PDF converter online creates optimized PDF files that are easy to email, upload, and store without compromising quality.",
            },

            {
              title: "Reliable Long Term Archiving",
              description:
                "Converting Excel to PDF online helps preserve spreadsheet data in a stable format, making PDFs ideal for long term storage and record keeping.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "How can I convert Excel to PDF online for free?",
              description:
                "Visit ShivaPDF.com and open the Excel to PDF converter. Select your Excel file, start the conversion, and download the resulting PDF to your device. This makes it easy to share spreadsheets in a widely supported document format."
            },
            {
              title: "Can I convert Excel to PDF without installing software?",
              description:
                "Yes, you can use ShivaPDF's browser-based Excel to PDF converter without installing a separate desktop application. Open the tool in a supported browser, select your spreadsheet, and follow the available conversion steps."
            },
            {
              title: "Is the Excel to PDF converter free?",
              description:
                "ShivaPDF offers online PDF tools to help you convert supported spreadsheet files to PDF for free, subject to any file size or usage limits displayed on the website."
            },
            {
              title: "Can I convert Excel to PDF without uploading my file?",
              description:
                "If local conversion is supported by the tool, your Excel file can be processed directly in your browser without uploading its contents to a remote server. Check the tool's processing behavior and privacy information before converting confidential spreadsheets."
            },
            {
              title: "Does ShivaPDF support XLS and XLSX files?",
              description:
                "The supported Excel formats depend on the converter's implementation. Check the upload area on ShivaPDF.com to confirm whether your spreadsheet format, such as XLS or XLSX, is supported."
            },
            {
              title: "Can I convert an Excel spreadsheet to PDF offline?",
              description:
                "You may need an internet connection to open ShivaPDF.com initially. Offline conversion is possible only if the converter and all required resources are available locally on your device."
            },
            {
              title: "Will converting Excel to PDF preserve the spreadsheet formatting?",
              description:
                "The converter aims to preserve the spreadsheet's layout, text, tables, and cell formatting. Results may vary depending on the workbook structure, print settings, fonts, formulas, and page layout."
            },
            {
              title: "Can I convert an Excel file with multiple sheets to PDF?",
              description:
                "Yes, if supported by the converter, you can export multiple worksheets into a PDF document. Review the available sheet selection and export settings to determine which worksheets will appear in the final file."
            },
            {
              title: "Can I convert only one worksheet from Excel to PDF?",
              description:
                "If worksheet selection is supported, you can choose a specific sheet to convert instead of exporting the entire workbook. This is useful when you want to share only one table or report."
            },
            {
              title: "Can I convert Excel to PDF without cutting off columns?",
              description:
                "To prevent columns from being cut off, adjust the spreadsheet's print area, page orientation, margins, and scaling before conversion if those options are available. Landscape orientation or fitting columns to one page may help wide spreadsheets."
            },
            {
              title: "Can I convert Excel to PDF on my mobile phone?",
              description:
                "Yes, you can access ShivaPDF.com through a supported browser on an iPhone, Android phone, or tablet. Select a supported Excel file and follow the converter's instructions to create your PDF."
            },
            {
              title: "Will Excel formulas work in the converted PDF?",
              description:
                "A PDF displays the spreadsheet's rendered content rather than functioning as an interactive spreadsheet. Formula results may appear as displayed values, but the formulas themselves generally cannot be recalculated in a standard PDF viewer."
            },
            {
              title: "Can I convert Excel charts and graphs to PDF?",
              description:
                "Charts and graphs can appear in the resulting PDF when they are supported by the converter and included in the exported worksheet or print area. Review the output to ensure that charts are readable and correctly positioned."
            },
            {
              title: "Can I convert a large Excel file to PDF?",
              description:
                "Large workbooks may require additional memory and processing time. Conversion limits depend on the tool, workbook complexity, and available device resources. Check any file size limits displayed on the website."
            },
            {
              title: "Are my Excel files safe when converting them to PDF?",
              description:
                "File privacy depends on how the converter processes documents. If conversion takes place entirely in your browser, the workbook contents do not need to be uploaded to a remote server. Verify the tool's processing method before converting sensitive financial or business files."
            },
            {
              title: "Can I convert Excel to PDF without creating an account?",
              description:
                "You can use the converter without creating an account if registration is not required by the website. Check the conversion page for any applicable usage restrictions."
            },
            {
              title: "Why does my converted PDF look different from my Excel file?",
              description:
                "Differences can occur because spreadsheets use print areas, page breaks, scaling, fonts, and worksheet dimensions that affect PDF output. Adjust the page layout and print settings before converting, then review the resulting PDF."
            },
            {
              title: "Can I convert Excel to a PDF with multiple pages?",
              description:
                "Yes, spreadsheets can be converted into multi-page PDF documents when their content extends across multiple printed pages. Page orientation, margins, scaling, and page breaks affect how the content is distributed."
            },
            {
              title: "How do I download my converted PDF?",
              description:
                "After conversion finishes, select the download option to save the PDF to your device. Open the downloaded file to verify that the spreadsheet content, formatting, and page layout are correct."
            },
            {
              title: "Why should I use ShivaPDF to convert Excel to PDF?",
              description:
                "ShivaPDF provides convenient browser-based PDF tools for converting and managing documents without requiring a separate desktop application. You can create PDF versions of supported spreadsheets for easier sharing, printing, and viewing."
            }
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default ExcelToPDFMain;
